export const MODULE_NAME = 'payment-thanks';
